import styled from "styled-components";

export const ProductBasicInformationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    padding-right: 5px;
    box-sizing: border-box;
`;

export const InfoGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 15px 20px;
`;

export const InfoGroupSeparator = styled.div`
    border-top: 1px solid #CCCCCC;
    margin-top: 15px;
`;

export const InfoGroupTitle = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 2px;
`;

export const InfoGroupContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: top;
`;

export const ProductModelPicture = styled.div`
    flex: 0 0 auto;
    width: 120px;
    height: 120px;
    margin-right: 40px;
    border-radius: 50%;
    border: 8px solid #CCCCCC;
    background-size: cover;
    background-position: center center;
`;

export const ProductDescriptionWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
`;

export const ProductDescriptionTitle = styled.div`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
`;

export const ProductDescriptionContent = styled.div`
    text-align: justify;
`;

export const ParameterGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: top;
    margin-top: 40px;
`;

export const ParameterGroupTitle = styled.div`
    font-size: 16px;
    font-weight: bold;
    width: 200px;
`;

export const ParameterGroupContent = styled.div`
    flex: 1 1 auto;
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-auto-rows: 60px;
    grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
`;

export const Parameter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ParameterName = styled.div`
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
`;

export const ParameterValue = styled.div`
    
`;